export const MOBILE_SIZE = 830;
